import {ReviewState} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'

export function reviewStateLabel(
  state: ReviewState,
  dismissedState: ReviewState = ReviewState.UNSPECIFIED,
  isQualifiedReviewer: boolean = true,
): string {
  switch (state) {
    case ReviewState.APPROVED:
      return isQualifiedReviewer ? 'approved' : 'recommended approval'
    case ReviewState.CHANGES_REQUESTED:
      return isQualifiedReviewer ? 'changes requested' : 'suggested changes'
    case ReviewState.COMMENTED:
      return 'commented'
    case ReviewState.DISMISSED: {
      return dismissedReviewLabel(dismissedState, isQualifiedReviewer)
    }
    case ReviewState.PENDING:
      return 'pending'
    case ReviewState.UNSPECIFIED:
      return 'reviewed'
  }
}

export function dismissedReviewLabel(dismissedState: ReviewState, isQualifiedReviewer: boolean = true): string {
  switch (dismissedState) {
    case ReviewState.APPROVED:
      return isQualifiedReviewer ? 'previously approved' : 'previously recommended approval'
    case ReviewState.CHANGES_REQUESTED:
      return isQualifiedReviewer ? 'previously requested changes' : 'previously suggested changes'
    case ReviewState.COMMENTED:
      return 'previously commented'
    default:
      return 'previously reviewed'
  }
}
